/* eslint-disable */
import 'bootstrap';
import axios from 'axios';
import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import router from './router';
import VueIntercom from 'vue-intercom';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import {apiHost, cpixdomain} from './config';
import {getCookie, setCookie, deleteCookie} from "./cookie";
import helpers from './helpers'
import App from './App.vue';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

Vue.use(Vuex)
Vue.use(VueIntercom, {appId: 'f1lcarew'});

// Global registration
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false;

var urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('token')) {
  deleteCookie('admin');
  deleteCookie('officeAdmin');
  deleteCookie('companyAdmin');
  //Set the cookie
  setCookie('token', urlParams.get('token'), 1);

  if (urlParams.has('type') && urlParams.get('type') === 'officeAdmin') {
    setCookie('admin', 1, 1);
    setCookie('officeAdmin', 1, 1);
  }

  if (urlParams.has('type') && urlParams.get('type') === 'companyAdmin') {
    setCookie('admin', 1, 1);
    setCookie('companyAdmin', 1, 1);
  }

  if (urlParams.has('type') && urlParams.get('type') === 'admin') {
    setCookie('admin', 1, 1);
  }

  window.history.replaceState({}, document.title, "/");
}

let authenticated = true;
if (!getCookie('token')) {
  window.location = cpixdomain + '/login.htm?backToDashboard';
  authenticated = false;
}

function auth(admin) {
  let token = getCookie('token');
  if(!token){
    return '';
  }
  if (admin) {
    // remove all the extra stuff
    return token.split(',')[0];
  }

  let impersonate = getCookie('impersonate');

  if (impersonate) {
    token += impersonate;
  }

  return token;
}

// setup axios
axios.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + auth(false);
  config.baseURL = apiHost;
  return config;
}, function (err) {
  return Promise.reject(err);
});
Vue.prototype.$http = axios;

const instance = axios.create({
  baseURL: apiHost,
  timeout: 1000,
  headers: {'Authorization': 'Bearer ' + auth(true)}
});
// This is used so that the token remains the admin users token for admin calls.
Vue.prototype.$httpadmin = instance;
Vue.prototype.$helpers = helpers;

if(authenticated){
  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app')
}

